import equal from 'fast-deep-equal/es6/react';
import { connect } from 'react-redux';
import { DatapointAutomationBlocker } from '@rossum/api-client/automationBlockers';
import { Message } from '@rossum/api-client/shared';
import { datapointBlockerSelector } from '../../redux/modules/annotation/selectors';
import {
  replaceSuggestedOperationsWithDatapointSelector,
  suggestedOperationsOptionsSelector,
  suggestedOperationsSelector,
} from '../../redux/modules/datapoints/suggestedOperations/selector';
import {
  AnyDatapointDataST,
  MatchedTriggerRuleDatapoint,
  SimpleDatapointDataST,
  SuggestedOperationWithMeta,
} from '../../types/datapoints';
import { State } from '../../types/state';
import { AnnotationValidation } from '../../types/user';
import Datapoint, { OwnProps } from './index';

type Props = Omit<OwnProps, keyof StateProps> & {
  message: Message | undefined;
  widthOverride?: number;
  active: boolean;
  data: AnyDatapointDataST;
  annotationValidationMode: AnnotationValidation | undefined;
};

const mapStateToProps = (state: State, ownProps: Props): StateProps => {
  const { data } = ownProps;

  const suggestedOperation =
    replaceSuggestedOperationsWithDatapointSelector(state)[ownProps.data.id];

  const suggestedOperationsSchemaIds =
    suggestedOperationsOptionsSelector(state).schemaIds;

  const automationBlockers = datapointBlockerSelector(state)[data.schemaId];

  return {
    automationBlockers: automationBlockers ?? [],
    matchedRules:
      state.datapoints.matchedTriggerRules.datapointLevel[data.id]?.[0],
    currentColumn: state.searchAndReplace.currentColumn,
    data,
    editingDatapointValue: state.ui.editingDatapointValue,
    searchPanelShown: state.search.shouldShow,
    suggestedOperation,
    suggestedOperationsSchemaIds,
    documentAutomated: state.annotation.automated ?? false,
    widthOverride: ownProps.widthOverride,
  };
};

type StateProps = {
  automationBlockers: DatapointAutomationBlocker[];
  currentColumn: string;
  data: AnyDatapointDataST;
  documentAutomated: boolean;
  editingDatapointValue: boolean;
  matchedRules: MatchedTriggerRuleDatapoint | undefined;
  searchPanelShown: boolean;
  suggestedOperation: SuggestedOperationWithMeta | undefined;
  suggestedOperationsSchemaIds: string[];
  widthOverride?: number;
};

export default connect<StateProps, null, Props, State>(
  mapStateToProps,
  null,
  null,
  {
    areOwnPropsEqual: (next: Props, prev: Props) =>
      !(
        next.active ||
        prev.active ||
        next.message?.content !== prev.message?.content ||
        !equal(
          (next.data as SimpleDatapointDataST).validationSources,
          (prev.data as SimpleDatapointDataST).validationSources
        ) ||
        next.isLoading !== prev.isLoading ||
        (next.data as SimpleDatapointDataST).content !==
          (prev.data as SimpleDatapointDataST).content ||
        next.widthOverride !== prev.widthOverride ||
        next.blockersVisible !== prev.blockersVisible ||
        next.annotationValidationMode !== prev.annotationValidationMode
      ),
    areStatesEqual: (next, prev) =>
      next.searchAndReplace.currentColumn ===
        prev.searchAndReplace.currentColumn &&
      next.datapoints.updatedTimestamp === prev.datapoints.updatedTimestamp &&
      suggestedOperationsSelector(next) === suggestedOperationsSelector(prev),
  }
)(Datapoint);
